<template>
    <div>
        <h1 class="page-title">Glosario</h1>
        <v-expansion-panel focusable>
            <v-expansion-panel-content v-for="(item,i) in Object.keys(glosario)" :key="item">
                <div slot="header"><span  class="termino">{{item}}</span></div>
                <v-card>
                    <v-card-text class="grey lighten-3"><span v-html="glosario[item]"></span></v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                glosario: {}
            }
        },
        created() {
            this.glosario = require('@/assets/glosario.json');
        }
    }
</script>
<style lang="scss" scoped>
    .termino {
        font-weight: bold;
    }
    h1 {
        text-align: center;
        margin-bottom: 1.5rem;
    }
</style>